import { render, staticRenderFns } from "./SearchLayout.vue?vue&type=template&id=224ac9db"
import script from "./SearchLayout.vue?vue&type=script&lang=js"
export * from "./SearchLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports